import { Route } from '@/core/entities/types/routes';
import { useApplicationContext } from '@/core/hooks/useApplicationContext';
import { validatePermission } from '@/core/utils/validatePermissionRoute';
import { BillingModel } from '@/modules/billing/entities/billing.enums';
import { User } from '@/modules/profile';
import { cloneDeep } from 'lodash';
import { useCallback } from 'react';
import { RouteObject } from 'react-router-dom';

interface UseHandleRoutesProps {
  routes: Route[];
  user: User;
  companyBillingModel?: BillingModel;
}

export const useHandleRoutes = ({ routes, user, companyBillingModel }: UseHandleRoutesProps) => {
  const { company } = useApplicationContext();

  const handleRoutes = useCallback(
    (items: Route[]): RouteObject[] => {
      const filteredItems: RouteObject[] = [];
      for (const item of items) {
        const hasPermissionToAccess = validatePermission({
          item,
          user,
          company,
          companyBillingModel,
        });

        if (hasPermissionToAccess) {
          const route = cloneDeep(item);

          if (item.children) {
            route.children = handleRoutes(item.children) as Route[];
          }

          filteredItems.push(route as RouteObject);
        }
      }

      return filteredItems;
    },
    [user, company, companyBillingModel],
  );

  return {
    handledRoutes: handleRoutes(routes),
  };
};
